export default function (WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}



// WEBPACK FOOTER //
// ./src/components/helpers/getDisplayName.js